import { breakpoints } from "@brightagency/headstart-common";
import styled, { css } from "styled-components";
import { colors } from "../../../utils/colors";

export const Outer = styled.div<{ topColor?: string; bottomColor?: string }>`
    position: relative;

    /* Top background */
    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 150px;
        background-color: ${({ topColor = "white" }) => topColor};

        ${breakpoints.large} {
            height: 50%;
        }
    }

    /* Bottom background */
    &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 150px);
        background-color: ${({ bottomColor = "white" }) => bottomColor};

        ${breakpoints.large} {
            height: 50%;
        }
    }

    > * {
        position: relative;
        z-index: 1;
    }
`;

export const Wrapper = styled.div<{ removeExtraBottomSpacing?: boolean }>`
    width: 100%;
    border-radius: 27px;
    padding: 40px 24px 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${colors.white};

    ${({ removeExtraBottomSpacing }) =>
        removeExtraBottomSpacing &&
        css`
            padding-bottom: 40px;
        `}

    ${breakpoints.large} {
        padding: 50px 60px 72px;
        flex-direction: row;

        ${({ removeExtraBottomSpacing }) =>
            removeExtraBottomSpacing &&
            css`
                padding-bottom: 50px;
            `}
    }
`;

export const ImageContainer = styled.div`
    margin-bottom: 16px;
    width: 100%;
    max-width: 185px;

    ${breakpoints.large} {
        margin-bottom: 0;
    }
`;

export const Content = styled.div`
    margin-bottom: 32px;
    text-align: center;
    flex-grow: 1;

    ${breakpoints.large} {
        text-align: left;
        margin: 0 48px;
    }

    &.no-image{
        ${breakpoints.large} {
            margin: 0 48px 0 0;
        }
    }
`;

export const Title = styled.h3`
    margin: 0 0 16px;
    font-size: 25px;
    color: ${colors.brandDark};

    ${breakpoints.large} {
        font-size: 32px;
    }
`;

export const Copy = styled.p`
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: ${colors.brandDark};

    ${breakpoints.large} {
        font-size: 18px;
    }
`;

export const ButtonContainer = styled.div`
    width: 100%;
    text-align: center;
    flex-shrink: 0;
    margin-bottom: 16px;

    ${breakpoints.large} {
        width: auto;
        min-width: 300px;
        margin-bottom: 0;
    }
`;
